<template>
    <div>

        <table class="table table-striped">

        <thead>

            <tr>

                <th>
                <div class="d-flex flex-row">

                <input class="form-control m-2"
                    v-model="LocucionFilter"
                    v-on:keyup="FilterFn()"
                    placeholder="Filtrar">
                    
                    <button type="button" class="btn btn-light"
                    @click="sortResult('Locucion',true)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
                    <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
                    </svg>
                    </button>
                    &nbsp;
                    <button type="button" class="btn btn-light"
                    @click="sortResult('Locucion',false)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
                    <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
                    </svg>
                    </button>

                </div>
                    Locuciones
                    
                </th>
                
                <th>Características</th>

            </tr>

        </thead>

        <tbody>
            <tr v-for="(loc, index) in locuciones" :key="index">

                <td>{{loc.Locucion}}</td>
                <td>
                    <!--
                        <a 
                        class="btn btn-primary btn-sm" href="#" role="button"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        @click="especificacionesClick(loc)"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                        </svg> Ver detalles </a>
                    -->

                    <b-button v-b-modal.modal-xl variant="primary" size="sm" @click="especificacionesClick(loc)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                        </svg>
                        Ver detalles
                    </b-button>

                </td>
            </tr>
        </tbody>

        </table>

            <!--
            <button id="spinner" class="btn btn-primary" type="button" disabled>
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                Cargando...
            </button>
            -->

        <b-modal id="modal-xl" size="lg" hide-footer hide-header centered>
        
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{modalTitle}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="$bvModal.hide('modal-xl')">
                </button>
            </div>

            <div class="modal-body">
                <div> 
                <div><!--<span>Locución</span><input type="text" class="form-control" v-model="Locucion">--></div>
                    <div><span v-if="Clasificacion != 'nan' && Clasificacion != ''"><b>Clasificación:</b> {{Clasificacion}}</span></div>
                    <div><span v-if="Significado != 'nan' && Significado != ''"><b>Significado:</b> {{Significado}}</span> </div>
                    <div><span v-if="Region != 'nan' && Region != ''"><b>Región:</b> {{Region}}</span> </div>
                    <div><span v-if="Traducciones != 'nan' && Traducciones != ''"><b>Traducciones:</b> {{Traducciones}}</span> </div>
                    <div><span v-if="Marcacion_gramatical != 'nan' && Marcacion_gramatical != ''"><b>Marcación gramatical:</b> {{Marcacion_gramatical}}</span> </div>
                    <div><span v-if="Ejemplo_1 != 'nan' && Ejemplo_1 != ''"><b>Ejemplo 1:</b> {{Ejemplo_1}}</span></div>
                    <div><span v-if="Ejemplo_2 != 'nan' && Ejemplo_2 != ''"><b>Ejemplo 2:</b> {{Ejemplo_2}}</span> </div>
                    <div><span v-if="Ejemplo_3 != 'nan' && Ejemplo_3 != ''"><b>Ejemplo 3:</b> {{Ejemplo_3}}</span> </div>
                    <div><span v-if="Ejemplo_4 != 'nan' && Ejemplo_4 != ''"><b>Ejemplo 4:</b> {{Ejemplo_4}}</span> </div>
                    <div><span v-if="Ejemplo_5 != 'nan' && Ejemplo_5 != ''"><b>Ejemplo 5:</b> {{Ejemplo_5}}</span> </div>
                    <div><span v-if="DRAE != 'nan' && DRAE != ''"><b>DRAE:</b> {{DRAE}}</span> </div>
                    <div><span v-if="Aspectos_morfologicos != 'nan' && Aspectos_morfologicos != ''"><b>Aspectos morfológicos:</b> {{Aspectos_morfologicos}}</span> </div>
                    
                    <div><span v-if="Variantes != 'nan' && Variantes != ''"><b>Variantes:</b> {{Variantes}}</span> </div>
                    <div><span v-if="Sinonimo != 'nan' && Sinonimo != ''"><b>Sinónimo:</b> {{Sinonimo}}</span> </div>
                    <div><span v-if="Antonimo != 'nan' && Antonimo != ''"><b>Antónimo:</b> {{Antonimo}}</span> </div>
                    
                    <div><span v-if="Palabras_diacriticas != 'nan' && Palabras_diacriticas != ''"><b>Palabras diacríticas:</b> {{Palabras_diacriticas}}</span> </div>
                    <div><span v-if="Numero != 'nan' && Numero != ''"><b>Número:</b> {{Numero}}</span></div>
                    <div><span v-if="Argumentos != 'nan' && Argumentos != ''"><b>Argumentos:</b> {{Argumentos}}</span></div>
                    <div><span v-if="Polaridad != 'nan' && Polaridad != ''"><b>Polaridad:</b> {{Polaridad}}</span> </div>
                    
                    <div><span v-if="Aspectos_pragmaticos != 'nan' && Aspectos_pragmaticos != ''"><b> Aspectos pragmáticos: </b> {{Aspectos_pragmaticos}}</span> </div>
                    <div><span v-if="Prosodia_puntuacion != 'nan' && Prosodia_puntuacion != ''"><b> Prosodia y puntuación: </b> {{Prosodia_puntuacion}}</span> </div>
                    <div><span v-if="Combinacion_otras_UF != 'nan' && Combinacion_otras_UF != ''"><b> Combinación con otras UF: </b> {{Combinacion_otras_UF}}</span> </div>
                    <div><span v-if="Posicion != 'nan' && Posicion != ''"><b> Posición: </b> {{Posicion}}</span> </div>
                    <div><span v-if="Registro != 'nan' && Registro != ''"><b> Registro: </b> {{Registro}}</span> </div>

                </div>

                <div style="margin-top: 10px;" v-if="AudioFileName != 'nan' && AudioFileName != ''">
                    <span> <b>Audio: </b>
                        <audio controls="controls" type="audio/mpeg" preload="preload" :src="AudioPath+AudioFileName">
                        </audio> 
                    </span>
                </div>
            </div>
        </b-modal>

        <!--
        <div style="margin-top: 20px;">
            <nav aria-label="Page navigation example">
            <ul class="pagination">
                <li class="page-item"><a class="page-link" href="#">Anterior</a></li>
                <li class="page-item"><a class="page-link" href="#">1</a></li>
                <li class="page-item"><a class="page-link" href="#">2</a></li>
                <li class="page-item"><a class="page-link" href="#">3</a></li>
                <li class="page-item"><a class="page-link" href="#">Siguiente</a></li>
            </ul>
            </nav>
        </div>
        -->

    </div>
</template>

<script>

import axios from 'axios';

export default {

    data(){

    return{
        locuciones:[],
        modalTitle:"",
        Locucion:"",
        LocucionID:0,
        Clasificacion:"",
        Significado:"",
        Region:"",
        Traducciones:"",
        Marcacion_gramatical:"",
        Ejemplo_1:"",
        Ejemplo_2:"",
        Ejemplo_3:"",
        Ejemplo_4:"",
        Ejemplo_5:"",
        DRAE:"",
        Aspectos_morfologicos:"",
        Variantes:"",
        Sinonimo:"",
        Antonimo:"",
        Palabras_diacriticas:"",
        Numero:"",
        Argumentos:"",
        Polaridad:"",
        Aspectos_pragmaticos:"",
        Prosodia_puntuacion:"",
        Combinacion_otras_UF:"",
        Posicion:"",
        Registro:"",
        LocucionFilter:"",
        LocucionIDFilter:"",
        LocucionesWithoutFilter:[],
        AudioFileName:"",
        AudioPath:"http://difraco.com.co:8000/Media/"
        }
    },

    methods:{
        refreshData(){
            axios.get("http://difraco.com.co:8000/locucion")
            .then((response)=>{
                this.locuciones=response.data;
                this.locucionesWithoutFilter=response.data;
            })
        },

        especificacionesClick(loc){
            this.modalTitle=loc.Locucion;
            this.Locucion=loc.Locucion;
            this.LocucionID=loc.LocucionID;
            this.Clasificacion=loc.Clasificacion;
            this.Significado=loc.Significado;
            this.Region=loc.Region;
            this.Traducciones=loc.Traducciones;
            this.Marcacion_gramatical=loc.Marcacion_gramatical;
            this.Ejemplo_1=loc.Ejemplo_1;
            this.Ejemplo_2=loc.Ejemplo_2;
            this.Ejemplo_3=loc.Ejemplo_3;
            this.Ejemplo_4=loc.Ejemplo_4;
            this.Ejemplo_5=loc.Ejemplo_5;
            this.DRAE=loc.DRAE;
            this.Aspectos_morfologicos=loc.Aspectos_morfologicos;
            this.Variantes=loc.Variantes;
            this.Sinonimo=loc.Sinonimo;
            this.Antonimo=loc.Antonimo;
            this.Palabras_diacriticas=loc.Palabras_diacriticas;
            this.Numero=loc.Numero;
            this.Argumentos=loc.Argumentos;
            this.Polaridad=loc.Polaridad;
            this.Aspectos_pragmaticos=loc.Aspectos_pragmaticos;
            this.Prosodia_puntuacion=loc.Prosodia_puntuacion;
            this.Combinacion_otras_UF=loc.Combinacion_otras_UF;
            this.Posicion=loc.Posicion;
            this.Registro=loc.Registro;
            this.LocucionFilter=loc.LocucionFilter;
            this.AudioFileName=loc.AudioFileName
        
    },

        addClick(){
            this.modalTitle="Agregar una locución";
            this.LocucionID=0;
            this.Locucion="";
            this.Clasificacion="";
            this.Significado="";
            this.Region="";
            this.Traducciones="";
            this.Marcacion_gramatical="";
            this.Ejemplo_1="";
            this.Ejemplo_2="";
            this.Ejemplo_3="";
            this.Ejemplo_4="";
            this.Ejemplo_5="";
            this.DRAE="";
            this.Aspectos_morfologicos="";
            this.Variantes="";
            this.Sinonimo="";
            this.Antonimo="";
            this.Palabras_diacriticas="";
            this.Numero="";
            this.Argumentos="";
            this.Polaridad="";
            this.Aspectos_pragmaticos="";
            this.Prosodia_puntuacion="";
            this.Combinacion_otras_UF="";
            this.Posicion="";
            this.Registro="";
            this.LocucionFilter="";
            this.AudioFileName=""
        },
        editClick(loc){
            this.modalTitle="Editar locución";
            this.LocucionID=loc.LocucionID;
            this.Locucion=loc.Locucion;
            this.Clasificacion=loc.Clasificacion;
            this.Significado=loc.Significado;
            this.Region=loc.Region;
            this.Traducciones=loc.Traducciones;
            this.Marcacion_gramatical=loc.Marcacion_gramatical;
            this.Ejemplo_1=loc.Ejemplo_1;
            this.Ejemplo_2=loc.Ejemplo_2;
            this.Ejemplo_3=loc.Ejemplo_3;
            this.Ejemplo_4=loc.Ejemplo_4;
            this.Ejemplo_5=loc.Ejemplo_5;
            this.DRAE=loc.DRAE;
            this.Aspectos_morfologicos=loc.Aspectos_morfologicos;
            this.Variantes=loc.Variante;
            this.Sinonimo=loc.Sinonimo;
            this.Antonimo=loc.Antonimo;
            this.Palabras_diacriticas=loc.Palabras_diacriticas;
            this.Numero=loc.Numero;
            this.Argumentos=loc.Argumentos;
            this.Polaridad=loc.Polaridad;
            this.Aspectos_pragmaticos=loc.Aspectos_pragmaticos;
            this.Prosodia_puntuacion=loc.Prosodia_puntuacion;
            this.Combinacion_otras_UF=loc.Combinacion_otras_UF;
            this.Posicion=loc.Posicion;
            this.Registro=loc.Registro;
            this.LocucionFilter=loc.LocucionFilter;
            this.AudioFileName=loc.AudioFileName
            
        },
        createClick(){
            axios.post("http://127.0.0.1:8000/locucion",{
                Locucion:this.Locucion,
                Clasificacion:this.Clasificacion,
                Significado:this.Significado,
                Region:this.Region,
                Traducciones:this.Traducciones,
                Marcacion_gramatical:this.Marcacion_gramatical,
                Ejemplo_1:this.Ejemplo_1,
                Ejemplo_2:this.Ejemplo_2,
                Ejemplo_3:this.Ejemplo_3,
                Ejemplo_4:this.Ejemplo_4,
                Ejemplo_5:this.Ejemplo_5,
                DRAE:this.DRAE,
                Aspectos_morfologicos:this.Aspectos_morfologicos,
                Variantes:this.Variantes,
                Sinonimo:this.Sinonimo,
                Antonimo:this.Antonimo,
                Palabras_diacriticas:this.Palabras_diacriticas,
                Numero:this.Numero,
                Argumentos:this.Argumentos,
                Polaridad:this.Polaridad,
                Aspectos_pragmaticos:this.Aspectos_pragmaticos,
                Prosodia_puntuacion:this.Prosodia_puntuacion,
                Combinacion_otras_UF:this.Combinacion_otras_UF,
                Posicion:this.Posicion,
                Registro:this.Registro,
                LocucionFilter:this.LocucionFilter,
                AudioFileName:this.AudioFileName
            })
            .then((response)=>{
                this.refreshData();
                alert(response.data);
            });
        },
        updateClick(){
            axios.put("http://127.0.0.1:8000/locucion",{
                LocucionID:this.LocucionID,
                Locucion:this.Locucion,
                Clasificacion:this.Clasificacion,
                Significado:this.Significado,
                Region:this.Region,
                Traducciones:this.Traducciones,
                Marcacion_gramatical:this.Marcacion_gramatical,
                Ejemplo_1:this.Ejemplo_1,
                Ejemplo_2:this.Ejemplo_2,
                Ejemplo_3:this.Ejemplo_3,
                Ejemplo_4:this.Ejemplo_4,
                Ejemplo_5:this.Ejemplo_5,
                DRAE:this.DRAE,
                Aspectos_morfologicos:this.Aspectos_morfologicos,
                Variantes:this.Variantes,
                Sinonimo:this.Sinonimo,
                Antonimo:this.Antonimo,
                Palabras_diacriticas:this.Palabras_diacriticas,
                Numero:this.Numero,
                Argumentos:this.Argumentos,
                Polaridad:this.Polaridad,
                Aspectos_pragmaticos:this.Aspectos_pragmaticos,
                Prosodia_puntuacion:this.Prosodia_puntuacion,
                Combinacion_otras_UF:this.Combinacion_otras_UF,
                Posicion:this.Posicion,
                Registro:this.Registro,
                LocucionFilter:this.LocucionFilter,
                AudioFileName:this.AudioFileName
            })
            .then((response)=>{
                this.refreshData();
                alert(response.data);
            });
        },
        deleteClick(id){
            if(!confirm("¿Está seguro que quiere borrar?")){
                return;
            }
            axios.delete("http://127.0.0.1:8000/locucion/"+id)
            .then((response)=>{
                this.refreshData();
                alert(response.data);
            });

        },
        FilterFn(){
            var LocucionIDFilter=this.LocucionIDFilter;
            var LocucionFilter=this.LocucionFilter;

            this.locuciones=this.locucionesWithoutFilter.filter(
                function(el){
                    return el.LocucionID.toString().toLowerCase().includes(
                        LocucionIDFilter.toString().trim().toLowerCase()
                    )&&
                    el.Locucion.toString().toLowerCase().includes(
                        LocucionFilter.toString().trim().toLowerCase()
                    )
                });
        },
        sortResult(prop,asc){
            this.locuciones=this.locucionesWithoutFilter.sort(function(a,b){
                if(asc){
                    return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
                }
                else{
                    return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
                }
            })
        },

        audioUpload(event){
            let formData=new FormData();
            formData.append('file',event.target.files[0]);
            axios.post(
                "http://127.0.0.1:8000/locucion/savefile",
                formData)
                .then((response)=>{
                    this.AudioFileName=response.data;
                });
        },

    },

    mounted:function(){
        this.refreshData();
    }

};
</script>
